import { NavLink, Outlet } from "react-router";
import { NAV } from "../nav";

/**
 * Chrome around every authenticated page.
 *
 * `react-router`, never `react-router-dom` -- the shim was removed in v8 and
 * every version of it pins a `react-router` inside GHSA-qwww-vcr4-c8h2, so an
 * npm override cannot reach the fix. eslint.config.js enforces this.
 */
export function Layout({ email, onSignOut }: { email: string | null; onSignOut: () => void }) {
  return (
    <div className="min-h-screen flex flex-col">
      {/* NOT sticky, on purpose: on a phone the whole point is that the chrome
          scrolls away and the merch gets the screen.

          `min-w-0` on the flex children is what stops the page scrolling
          sideways. A flex item's default `min-width: auto` refuses to shrink
          below its content, so the nav and the email pushed the header to about
          680px of intrinsic width against a ~390px viewport, and the whole
          document scrolled horizontally. The nav scrolls WITHIN ITSELF instead. */}
      <header className="merch-header border-b border-neutral-800 px-3 sm:px-4 pb-2 sm:pb-3 flex items-center gap-3 sm:gap-4">
        <NavLink to="/" className="merch-wordmark shrink-0" aria-label="Band Merch home">
          <img src="/mark.svg" alt="" className="h-9 w-9 rounded-lg" />
          <span className="hidden min-[460px]:inline">Band Merch</span>
        </NavLink>
        <nav className="flex gap-3 text-sm min-w-0 overflow-x-auto whitespace-nowrap [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
          {NAV.map((entry) => (
            <NavLink
              key={entry.to}
              to={entry.to}
              // `end` on the index route only. Without it "/" stays active on
              // every path, because NavLink matches by prefix.
              end={entry.to === "/"}
              className={({ isActive }) =>
                `merch-nav-link${isActive ? " is-active" : ""}`
              }
            >
              {entry.label}
            </NavLink>
          ))}
        </nav>
        <div className="ml-auto flex shrink-0 items-center gap-3 text-sm text-neutral-400">
          {/* The address is ~150px of monospace that a phone has no room for and
              no use for -- there is exactly one account. Sign out stays. */}
          <span className="hidden font-mono sm:inline">{email ?? "—"}</span>
          <button onClick={onSignOut} className="underline hover:text-neutral-200">
            Sign out
          </button>
        </div>
      </header>
      {/* Tighter gutters on a phone: 8px each side rather than 16 is another
          16px of card width, which is most of a price. */}
      <main className="merch-main flex-1 p-3 sm:p-5">
        <Outlet />
      </main>
    </div>
  );
}
